import _get from 'lodash/get';
import request from './request';

const getIsEU = async(config) => {

    const url = _get(config, 'advertising.userLocationApi', 'https://terra.mlb.com');
    let isEU = false;

    try {

        const data = await request(url);
        isEU = _get(data, 'isEuropeanUnion', false);

    } catch (error) {

        console.error(error);

    }

    return isEU;

};

export default getIsEU;
